import { Box } from '@chakra-ui/react';
import { LexicalGenericInnerComponentProps } from './LexicalGenericComponent';

export default function LexicalDividerComponent({ isEditable }: LexicalGenericInnerComponentProps) {
  return <div className="w-full border-dashed border-b-[1px] border-main" />;
}
